/* eslint-disable
    eqeqeq,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import React from 'react';

import { renderComponent } from '@trello/component-wrapper';
import { sendErrorEvent } from '@trello/error-reporting';
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';
import ReactDOM from '@trello/react-dom-wrapper';

import {
  LazyTeamOnboardingPupPopover,
  LazyTeamOnboardingPupTooltip,
} from 'app/src/components/BusinessClassTeamOnboardingPupPopover';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const unmountTeamOnboardingPupPopover = function (this: any) {
  if (this.teamOnboardingPupPopoverDiv != null) {
    return ReactDOM.unmountComponentAtNode(this.teamOnboardingPupPopoverDiv);
  }
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const unmountTeamOnboardingPupTooltip = function (this: any) {
  if (this.teamOnboardingPupTooltipDiv != null) {
    return ReactDOM.unmountComponentAtNode(this.teamOnboardingPupTooltipDiv);
  }
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const renderTeamOnboardingPupTooltip = function (this: any) {
  if (this.model.viewState.get('showSidebar')) {
    return;
  }

  return setTimeout(() => {
    const tooltip = (
      <LazyTeamOnboardingPupTooltip
        // eslint-disable-next-line react/jsx-no-bind
        onDismiss={() => this.unmountTeamOnboardingPupTooltip()}
      />
    );

    this.teamOnboardingPupTooltipDiv = document.createElement('div');
    $(this.teamOnboardingPupTooltipDiv).insertAfter(
      '.show-sidebar-button-react-root',
    );
    return ReactDOM.render(tooltip, this.teamOnboardingPupTooltipDiv);
  }, 1000);
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const renderTeamOnboardingPupPopover = function (this: any) {
  try {
    const org = this.model.getOrganization();

    if (org == null) {
      return;
    }

    if (this.teamOnboardingPupPopoverDiv == null) {
      const targetDiv = this.el.querySelector(
        '#team-onboarding-pup-popover-target',
      );

      if (targetDiv != null) {
        this.teamOnboardingPupPopoverDiv = targetDiv;
      } else {
        $('.board-main-content', this.$el).append(
          "<div id='team-onboarding-pup-popover-target'></div>",
        );
        this.teamOnboardingPupPopoverDiv = this.el.querySelector(
          '#team-onboarding-pup-popover-target',
        );
      }
    }

    const boardId = this.model.get('id');

    return renderComponent(
      <LazyTeamOnboardingPupPopover
        orgId={org.id}
        boardId={boardId}
        // eslint-disable-next-line react/jsx-no-bind
        onShowPowerUps={() => this.toggleDirectory()}
        // eslint-disable-next-line react/jsx-no-bind
        onDismissed={() => this.renderTeamOnboardingPupTooltip()}
      />,
      this.teamOnboardingPupPopoverDiv,
    );
  } catch (err) {
    sendErrorEvent(err, {
      tags: {
        ownershipArea: 'trello-mocha',
        feature: 'Team Onboarding',
      },
      extraData: {
        component: 'board-view-team-onboarding-pups',
      },
    });
  }
};
